import React from 'react';
import styles from './Performance.module.css';

interface SUPSComponent extends React.FC {
  title?: string;
}

const SUPS: SUPSComponent = () => {
  return (
    <div>
      <div className={styles.metricSection}>
        <strong>Metric Descriptions</strong>
        <ul>
          <li>Signed up for Product Sync – Is the store you are logged in as active on Product Sync program</li>
          <li>YTD Sales Amount – The number of online sales (YTD) have come from products matched on Product Sync</li>
          <li>YTD Units Sold - The number of online units that have sold (YTD) from products matched through the Product Sync program</li>
          <li>Crosslink Matches Made – The total amount of SKUs matched through the Product Sync program</li>
          <li>Crosslink Matches Waiting – The total amount of SKUs that are recommended to be matched, based on UPC, MFG # or SKU # matches from your POS store feed and Ace&apos;s database.</li>
        </ul>
      </div>

      <div className={styles.metricSection}>
        <strong>Supporting Details</strong>
        <p>
          Crosslink Matches Waiting - Items will be continually added to Ace&apos;s database; therefore, you should log into the Product Sync program and either match or reject the items that are waiting.
        </p>
      </div>

      <div className={styles.metricSection}>
        <strong>Goal</strong>
        <p>
          Every store to be signed up for Product Sync and all crosslink matches that are waiting to either be made or rejected.
        </p>
      </div>

      <div className={styles.metricSection}>
        <strong>Update Cadence</strong>
        <p>
          All metrics are updated daily.
        </p>
      </div>

      <div className={styles.metricSection}>
        <strong>Take Action</strong>
        <p>
          If you are not signed up for Product Sync, navigate to the ACENET page and fill out the Product Sync Retailer Agreement. Once signed up, the Product Sync program option will appear in the drop down under Marketing on ACENET the following day (including for all stores in a multi-store chain). If you have any recommended matches waiting, log into the Product Sync crosslink tool and match or reject all recommendations.
        </p>
      </div>
    </div>
  );
};

SUPS.title = 'Product Sync';
export default SUPS;
